import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../constants/endpoints";
import api from "../../services/instance";

export const getProfessionalsAPI = createAsyncThunk(
    "getProfessionalsAPI",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.getAllProfessionals(payload));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const getSingleProfessionalAPI = createAsyncThunk(
    "getSingleProfessionalAPI",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.getSingleProfessional(id));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const UpdateProfessionalStatusAPI = createAsyncThunk(
    "UpdateProfessionalStatusAPI",
    async (data, { rejectWithValue }) => {
        const id = data?.id
        const status = data?.status
        try {
            const response = await api.post(endpoints.updateProfessionalStatus(id, status));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

const initialState = {
    loading: false,
    professionals: [],
    singleProfessional: "",
    analytics: {
        total: 0,
        active: 0,
        pending: 0,
        blocked: 0,
    },
    pagination: {
        current_page: 1,
        total_pages: 1,
        total: 0,
        per_page: 10,
    }
}

const superAdminProfessionalSlice = createSlice({
    initialState,
    name: "superAdminProfessionalSlice",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getProfessionalsAPI.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(getProfessionalsAPI.fulfilled, (state, action) => {
            const professionalsData = action.payload.data.data.professionals;
            state.professionals = professionalsData.data;
            state.analytics = action.payload.data.data.analytics;
            state.pagination = {
                current_page: professionalsData.current_page,
                total_pages: professionalsData.last_page,
                total: professionalsData.total,
                per_page: professionalsData.per_page,
            };
            state.loading = false;
        });

        builder.addCase(getProfessionalsAPI.rejected, (state, action) => {
            state.loading = false;
        });

        // GET SINGLE PROFESSIONAL

        builder.addCase(getSingleProfessionalAPI.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(getSingleProfessionalAPI.fulfilled, (state, action) => {
            state.singleProfessional = action.payload.data.data;
            state.loading = false;
        });

        builder.addCase(getSingleProfessionalAPI.rejected, (state, action) => {
            state.loading = false;
        });
    }
});

export const { } = superAdminProfessionalSlice.actions
export default superAdminProfessionalSlice.reducer